import { render, staticRenderFns } from "./error-logger.vue?vue&type=template&id=776ba64f&"
import script from "./error-logger.vue?vue&type=script&lang=js&"
export * from "./error-logger.vue?vue&type=script&lang=js&"
import style0 from "./error-logger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "error-logger.vue"
export default component.exports